module.exports = __webpack_public_path__ + "static/media/AboutPage__Tammara.c4356540.png";